import { useQuery } from "@tanstack/react-query";
import { queryKeys, type QueryOptions } from "@/lib/react-query";
import { apiListSubjectLookup } from "../services/curriculumService";
import type { Subject } from "../types/curriculum.types";

const DEFAULT_OPTIONS = {
  staleTime: 1000 * 60 * 10,
  gcTime: 1000 * 60 * 30,
  refetchOnWindowFocus: false,
} as const;

/** Subjects via GET api/v1/helpers/get-subjects?board_id={boardId}&class_id={classId}. */
export function useSubjectLookup(
  boardId: number | string | undefined,
  classId: number | string | undefined,
  options?: QueryOptions<Subject[]>,
) {
  const enabled = Boolean(boardId && classId) && (options?.enabled ?? true);
  return useQuery({
    queryKey: queryKeys.boards.subjectLookup(boardId, classId),
    queryFn: async () =>
      await apiListSubjectLookup(boardId as number | string, classId as number | string),
    enabled,
    ...DEFAULT_OPTIONS,
    ...options,
  });
}
